"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPanelsPreferences = void 0;
const getActiveWorkspace_1 = require("../utilities/getActiveWorkspace");
function setPanelsPreferences(draft, action) {
    if (action.payload) {
        const currentWorkspacePreferences = (0, getActiveWorkspace_1.getActiveWorkspace)(draft);
        const { key, value } = action.payload;
        const panels = currentWorkspacePreferences.formatting.panels;
        if (value?.nuclei) {
            const { nuclei, ...commonPreferences } = value;
            panels[key] = {
                ...commonPreferences,
                nuclei: { ...panels[key]?.nuclei, ...nuclei },
            };
        }
        else {
            panels[key] = value;
        }
    }
}
exports.setPanelsPreferences = setPanelsPreferences;
